import "./FormSubTitleWithTooltipComponent.scss";
import TooltipComponent from "../tooltip/tooltipComponent";
import HelpIcon from "@mui/icons-material/Help";
import React from "react";

interface FormSubTitleWithTooltipComponentProps {
    title: string;
    tooltipData?: string;
}

const FormSubTitleWithTooltipComponent = (props: FormSubTitleWithTooltipComponentProps) => {
    const {title, tooltipData} = props;
    return (
        <div className={'form-sub-title-with-tooltip-component'}>
            <div className="form-sub-title-with-tooltio">
                <div className="form-sub-title">
                    {title}
                </div>
                {tooltipData ?
                    <TooltipComponent tooltip={tooltipData} arrow={true}>
                        <span className="mrg-left-10" id={'tooltip_' + tooltipData}><HelpIcon color={'action'}/></span>
                    </TooltipComponent> : ''
                }
            </div>
        </div>
    );

};

export default FormSubTitleWithTooltipComponent;